import makePage from 'modules/makePage';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import Page from 'modules/Page';
import { i18n } from 'i18n';
import * as constants from './constants';
import { BreakingSchedulePageParams } from './constants';

const BreakingSchedulePage = lazyWithSuspense(() => import('./BreakingSchedulePage'));

const page: Page<BreakingSchedulePageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: false,
  component: makePage<BreakingSchedulePageParams>({
    WrappedPage: BreakingSchedulePage,
    titleFn: () => i18n._(constants.TITLE),
    parentPathTemplate: '/qaqc/dashboard',
    parentTitleFn: () => i18n._(constants.TITLE),
  }),
};

export default page;
